import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {HierarchyTreeComponent} from '../../hierarchy-tree/hierarchy-tree.component';
import {Observable} from 'rxjs';
import {SiteBuilder} from '../../../model/builder/site.builder';
import {HierarchyService} from '../../../service/hierarchy.service';
import {HierarchyBackupService} from '../../../service/hierarchy-backup.service';

@Component({
  selector: 'app-export-dialog',
  templateUrl: './export-dialog.component.html',
  styleUrls: ['./export-dialog.component.css']
})
export class ExportDialogComponent implements OnInit {
  public sites = [];
  constructor(
              public dialogRef: MatDialogRef<ExportDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.sites = data.sites;
  }

  ngOnInit() {
/*    if (this.sites.length == 0) {
        Observable.combineLatest([
          this.hierarchyService.loadHierarchy(),
          this.hierarchyBackupService.loadBackup()
        ]).subscribe(sitesVO => {
          sitesVO[0].forEach(siteVO => {
            this.sites.push(siteVO);
          });
        })
    }*/
  }

}



// WEBPACK FOOTER //
// ./src/app/view/intelcia-tree/export-dialog/export-dialog.component.ts